import { createFileRoute, useSearch } from '@tanstack/react-router'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { TeamSidebar, type TeamSection } from '@/components/settings/team-sidebar'
import { TeamMembersSection } from '@/components/settings/organization/team-members-section'
import { RolesSection } from '@/components/settings/organization/roles-section'
import { requirePermission, PermissionDeniedRoute } from '@/lib/require-permission-guard'

type TeamSearch = {
  section?: TeamSection
}

export const Route = createFileRoute('/_app/_settings/team')({
  component: TeamPage,
  validateSearch: (search: Record<string, unknown>): TeamSearch => {
    return {
      section: (search.section as TeamSection) || 'team',
    }
  },
  beforeLoad: async ({ context }) => {
    await requirePermission(context.queryClient, 'TeamManage', 'team settings')
  },
  errorComponent: PermissionDeniedRoute,
})

function TeamPage() {
  useBreadcrumbFromRoute()
  const search = useSearch({ from: '/_app/_settings/team' })
  const currentSection = search.section || 'team'

  return (
    <div className="flex h-full overflow-hidden">
      <div className="scroll-fade-y flex-shrink-0 overflow-y-auto">
        <TeamSidebar />
      </div>
      <div className="flex flex-1 flex-col overflow-y-auto">
        <div className="flex flex-col gap-4 p-6">
          {currentSection === 'team' && <TeamMembersSection />}
          {currentSection === 'roles' && <RolesSection />}
        </div>
      </div>
    </div>
  )
}
